/* eslint-disable no-unused-vars */
import React from 'react';
import StockTable from '../components/StockTable';

const SetConfigPage = ({
  setCategory = 'วัสดุคงทน',
  setSetCategory,
  selectedComponents = [],
  setSelectedComponents,
  newMasterItem = '',
  setNewMasterItem,
  handleImageUpload,
  isUploading = false,
  imageUrl = '',
  itemMaster = [],
  supplies = [],
  resetForm,
  handleSaveBox,
  isEditing = false,
  getStatusConfig = () => ({ label: '' }),
  startEdit,
  handleDeleteMaster,
  handleUpdateAmount,
}) => {
  return (
    <div>
      <div style={{ background: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
        <h2>⚙️ สร้าง/แก้ไขชุด (Set Configuration)</h2>
        <p style={{ color: '#666', fontSize: '0.9em' }}>เลือกวัสดุคงทนหรือหัวกรอเพื่อรวมเป็นชุดเดียว หรือแก้ไขข้อมูลพิกัดของชุดที่มีอยู่แล้ว</p>

        <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '10px', marginBottom: '20px' }}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', fontWeight: 'bold', color: '#555', marginBottom: '5px' }}>ประเภทชุดที่ต้องการสร้าง *</label>
            <select
              value={setCategory}
              onChange={(e) => {
                if (setSetCategory) setSetCategory(e.target.value);
                if (setSelectedComponents) setSelectedComponents([]);
              }}
              style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '1em' }}
            >
              <option value="วัสดุคงทน">🛠️ ชุดวัสดุคงทน (ชุดตรวจ, ชุดผ่าตัด ฯลฯ)</option>
              <option value="หัวกรอ">🦷 ชุดหัวกรอ</option>
            </select>
          </div>

          <input
            placeholder="ชื่อชุดเครื่องมือ (เช่น ชุดทำแผลใหญ่)..."
            value={newMasterItem}
            onChange={(e) => setNewMasterItem && setNewMasterItem(e.target.value)}
            style={{ width: '100%', marginBottom: '15px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px' }}
          />

          <div style={{ marginBottom: '15px', padding: '10px', background: '#fff', border: '1px dashed #ccc' }}>
            <label style={{ fontWeight: 'bold' }}>📸 รูปภาพสำหรับชุดนี้:</label>
            <input type="file" accept="image/*" onChange={handleImageUpload} style={{ display: 'block', marginTop: '5px' }} />
            {isUploading && <p style={{ color: '#f39c12', margin: '5px 0' }}>⏳ กำลังอัปโหลด...</p>}
            {imageUrl && <img src={imageUrl} alt="set-preview" style={{ maxWidth: '150px', marginTop: '10px', borderRadius: '5px', border: '1px solid #ddd' }} />}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px', maxHeight: '200px', overflowY: 'auto', padding: '10px', border: '1px solid #eee', background: '#fff' }}>
            {itemMaster.filter(masterLot => masterLot.category === setCategory && !masterLot.is_set).map(masterLot => (
              <label key={masterLot.id} style={{ fontSize: '0.9em', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="checkbox"
                  checked={selectedComponents.includes(masterLot.id)}
                  onChange={(e) => {
                    if (!setSelectedComponents) return;
                    if (e.target.checked) setSelectedComponents(prev => [...prev, masterLot.id]);
                    else setSelectedComponents(prev => prev.filter(id => id !== masterLot.id));
                  }}
                />
                {masterLot.item_name}
              </label>
            ))}
            {itemMaster.filter(masterLot => masterLot.category === setCategory && !masterLot.is_set).length === 0 && (
              <div style={{ color: '#999', fontSize: '0.9em' }}>ไม่มีไอเทมชิ้นเดี่ยวในหมวดหมู่นี้ให้จัดชุด</div>
            )}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '15px' }}>
            <button onClick={resetForm} style={{ padding: '10px 20px', background: '#95a5a6', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>ล้างฟอร์ม</button>
            <button onClick={handleSaveBox} style={{ padding: '10px 20px', background: '#9b59b6', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>{isEditing ? 'อัปเดตชุด' : 'บันทึกแม่แบบชุด'}</button>
          </div>
        </div>

        <h3>📦 รายการชุดตรวจ / ชุดหัวกรอ ในระบบ</h3>
        {itemMaster.filter(masterLot => masterLot.is_set && masterLot.category !== 'กล่องหัวกรอ').map(set => {
          const lots = itemMaster.filter(masterLot => masterLot.item_name === set.item_name);
          const usable = lots.reduce((total, masterLot) => {
            const lotAmt = supplies.filter(s => s.master_id === masterLot.id).reduce((sum, s) => sum + s.item_amount, 0);
            return getStatusConfig(lotAmt, masterLot.exp_date)?.label === 'หมดอายุ' ? total : total + lotAmt;
          }, 0);

          const isHandpieceSet = set.category === 'หัวกรอ';

          return (
            <details key={set.id} style={{ marginBottom: '10px', border: `2px solid ${isHandpieceSet ? '#f8bbd0' : '#9b59b6'}`, borderRadius: '8px', background: isHandpieceSet ? '#fce4ec' : '#faf5fc' }}>
              <summary style={{ padding: '15px', cursor: 'pointer', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ color: isHandpieceSet ? '#880e4f' : '#8e44ad' }}>
                  {isHandpieceSet ? '📦 ชุดหัวกรอ: ' : '📦 ชุดตรวจ: '} {set.item_name}
                  {(set.cabinet || set.shelf || set.row) && (
                    <span style={{ marginLeft: '10px', fontSize: '0.85em', color: '#7f8c8d', background: '#fff', padding: '4px 8px', borderRadius: '12px', border: '1px solid #e0e0e0' }}>
                      📍 {set.cabinet ? `ตู้: ${set.cabinet}` : ''} {set.shelf ? `ชั้น: ${set.shelf}` : ''} {set.row ? `แถว: ${set.row}` : ''}
                    </span>
                  )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ fontSize: '0.85em', color: '#666' }}>พร้อมใช้: {usable} ชุด</span>
                  <button onClick={() => startEdit && startEdit(set)} style={{ background: '#fff', color: '#333', border: '1px solid #ccc', borderRadius: '3px', cursor: 'pointer', fontSize: '0.8em', padding: '4px 8px' }}>⚙️ แก้ไข</button>
                  <button onClick={() => { if (window.confirm("ลบชุดนี้?")) handleDeleteMaster && handleDeleteMaster(set.id); }} style={{ background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer' }}>🗑️</button>
                </div>
              </summary>
              <div style={{ padding: '15px', background: '#fff' }}>

                {lots[0]?.image_url?.split('|')[0] && (
                  <div style={{ marginBottom: '20px', padding: '10px', background: '#fce4ec', borderRadius: '8px', border: '1px dashed #f48fb1', display: 'flex', gap: '15px', alignItems: 'center' }}>
                    <div>
                      <strong style={{ color: '#880e4f' }}>📸 ภาพรวมของชุดนี้:</strong>
                    </div>
                    <img src={lots[0].image_url.split('|')[0]} alt={set.item_name} style={{ maxHeight: '120px', borderRadius: '8px', border: '2px solid #fff', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }} />
                  </div>
                )}

                <strong>ประกอบด้วย ({set.components?.length || 0} รายการ):</strong>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: '10px', margin: '10px 0 20px 0' }}>
                  {set.components?.map(compId => {
                    const compItem = itemMaster.find(i => i.id === compId);
                    if (!compItem) return null;
                    return (
                      <div key={compId} style={{ border: '1px solid #f8bbd0', borderRadius: '8px', padding: '10px', textAlign: 'center', background: '#fffafb', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                        {compItem.image_url?.split('|')[0] ? (
                          <img src={compItem.image_url.split('|')[0]} alt={compItem.item_name} style={{ width: '70px', height: '70px', objectFit: 'contain', borderRadius: '4px', marginBottom: '8px', border: '1px solid #eee', background: '#fff' }} />
                        ) : (
                          <div style={{ width: '70px', height: '70px', background: '#f5f5f5', borderRadius: '4px', margin: '0 auto 8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.7em', color: '#aaa', border: '1px solid #eee' }}>ไม่มีรูป</div>
                        )}
                        <div style={{ fontSize: '0.85em', fontWeight: 'bold', color: '#880e4f', lineHeight: '1.2', wordWrap: 'break-word' }}>
                          {compItem.item_name}
                        </div>
                      </div>
                    );
                  })}
                </div>

                <StockTable lots={lots} supplies={supplies} category={lots[0]?.category} onUpdate={handleUpdateAmount} onDelete={handleDeleteMaster} onEditLot={startEdit} />
              </div>
            </details>
          );
        })}
      </div>
    </div>
  );
};

export default SetConfigPage;
